import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import type { ReactNode } from "react";

export interface Select2MenuItemProps {
  label: ReactNode;
  selected?: boolean;
  onClick?: () => void;
  dotColor?: string;
  count?: number | string;
}

export function Select2MenuItem({
  label,
  selected = false,
  onClick,
  dotColor,
  count,
}: Select2MenuItemProps) {
  const theme = useTheme();

  return (
    <MenuItem
      onClick={onClick}
      selected={selected}
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1.25,
        px: 1.25,
        py: 0.875,
        borderRadius: 0.75,
        color: theme.palette.text.primary,
        "&.Mui-selected": {
          backgroundColor: theme.palette.primary._states.selected,
          "&:hover": {
            backgroundColor: theme.palette.primary._states.hover,
          },
        },
      }}
    >
      <Box
        component="span"
        aria-hidden
        sx={{ display: "flex", alignItems: "center", flex: "none" }}
      >
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          {selected ? (
            <path
              d="M19 3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.11 21 21 20.1 21 19V5C21 3.9 20.11 3 19 3ZM10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z"
              fill={theme.palette.primary.main}
            />
          ) : (
            <path
              d="M4 20V4H20V20H4ZM4.775 19.225H19.225V4.775H4.775V19.225ZM4.775 19.225V4.775V19.225Z"
              fill={theme.palette.text.primary}
            />
          )}
        </svg>
      </Box>
      {dotColor && (
        <Box
          aria-hidden
          sx={{
            width: 8,
            height: 8,
            borderRadius: "50%",
            backgroundColor: dotColor,
            ml: -0.25,
            flex: "none",
          }}
        />
      )}
      <Typography
        component="span"
        variant="body2"
        sx={{ flex: 1, color: "inherit" }}
      >
        {label}
      </Typography>
      {count !== undefined && (
        <Typography
          component="span"
          variant="body2"
          sx={{
            ml: "auto",
            color: theme.palette.text.secondary,
          }}
        >
          {count}
        </Typography>
      )}
    </MenuItem>
  );
}
